import { RootState } from '..';
import {UsersState} from './types';
import {createSelector} from "reselect";

const usersSelector: (state: RootState) => UsersState = (state: RootState) => state.users;

export const selectUsers = createSelector(usersSelector, (items => {
    return items.users;
}))
